import * as React from 'react';
import { Row, Col } from 'antd';
import { observer } from 'mobx-react';
import { Prompt } from 'react-router';

import { ProductEditorController } from 'src/app/products/products/parts/product-editor.controller';
import { BooleanView } from 'src/core/ui/boolean.view';
import { TabLanguageController } from 'src/core/ui/language/tab-language.controller';
import { PolicyRuleDataService } from 'src/app/bookings/policy-rules/policy-rule-form.data';
import { GenericPolicyFormView } from 'src/app/bookings/policies/generic-policy-form.view';
import { ContextService } from 'src/core/services/context.service';

interface Props extends ComponentViewProps<QuotePolicyItem> {
	title: string,
	save: () => Promise<void>;
	cancel: () => void;
	mode: ControlMode;
	onModeChange: (mode: ControlMode) => void;
	policyRuleDataService: PolicyRuleDataService;
	breadcrumb: any[];
	goToCard: (text: any, key: string, model: PolicyRuleItem) => void;
	contextService: ContextService;
}

@observer
export class QuoteProductPolicyFormView extends React.Component<Props, {}> {
	render(): React.ReactNode {
		const { model, mode, setBusy, contextService } = this.props;
		const translations = (model as any).dynamicProperties['displayName'];
		const array: TabLanguageModel[] = [
			{
				title: 'Name',
				dynamicProperties: translations,
				rows: 2
			}
		];

		return (
			<React.Fragment>
				<Prompt
					when={contextService.isDirty}
					message={location => `If you go to ${location.pathname}, all changes will be lost. Are you sure you want to continue?`}
				/>
				<GenericPolicyFormView
					rulesSections={['general', 'product']}
					policyRuleOwner={{
						quotePolicyId: model.id,
						quotePolicy: model
					}}
					{...this.props}
				>
					<Row>
						<Col xs={24}>
							<TabLanguageController
								model={model}
								dynamicProperties={array}
								mode={mode}
								setBusy={setBusy}
								isRichTextBox={false}
							/>
						</Col>
						<Col xs={24}>
							<ProductEditorController
								required
								label="Product"
								value={model.productId}
								onChanged={(item) => {
									model.productId = item != null ? item.id : null;
								}}
								mode={mode}
								onGetErrorMessage={() => model.validate(false, 'productId')}
								setBusy={setBusy}
							/>
						</Col>
						<Col xs={24}>
							<BooleanView
								label="Active"
								value={model.isActive}
								onChanged={(newVal) => {
									model.isActive = newVal;
								}}
								mode={this.props.mode}
							/>
						</Col>
					</Row>
				</GenericPolicyFormView>
			</React.Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/quote-product-policies/form/quote-product-policy-form.view.tsx